import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DATE_FORMAT } from './date-format';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatOptionModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatAccordion, MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatMenuModule } from '@angular/material/menu';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatSortModule } from '@angular/material/sort';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatSnackBarModule,
        MatIconModule,
        MatInputModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatSelectModule,
        MatOptionModule,
        MatRadioModule,
        FormsModule,
        MatExpansionModule,
        MatStepperModule,
        MatTableModule,
        MatDialogModule,
        MatTabsModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatAutocompleteModule,
        MatAccordion,
        MatExpansionPanel,
        MatListModule,
        MatDatepickerModule,
        MatPaginatorModule,
        MatPaginator,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatSidenavModule,
        ClipboardModule,
        MatSortModule,
    ],
    exports: [
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatSnackBarModule,
        MatInputModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatIconModule,
        MatSelectModule,
        MatOptionModule,
        MatRadioModule,
        FormsModule,
        ReactiveFormsModule,
        MatExpansionModule,
        MatStepperModule,
        MatTableModule,
        MatDialogModule,
        MatTabsModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatAutocompleteModule,
        MatAccordion,
        MatExpansionPanel,
        MatListModule,
        MatDatepickerModule,
        MatPaginatorModule,
        MatPaginator,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatSidenavModule,
        ClipboardModule,
        MatSortModule,
    ],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE],
        },
        { provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT },
    ],
})
export class MaterialModule {}
